import { IFeature } from 'graphql/types';
import { useFeature } from 'common/hooks/useFeature';
import { Loader } from 'common/components/Loader';
import { BasePage } from 'hydra/pages/BasePage';

import { FeatureUpgradeContent } from './FeatureUpgradeContent';

interface IFeatureGateProps {
    feature: IFeature;
    fallback?: React.ReactNode;
    hideUpgrade?: boolean;
    children: React.ReactNode;
}

export const FeatureGate = ({
    feature,
    fallback = null,
    hideUpgrade = false,
    children,
}: IFeatureGateProps) => {
    const { canUse, userCanSeeUpgrade, loading } = useFeature(feature);

    if (loading) return <Loader />;

    if (!canUse) {
        // Managers/Owners see upgrade prompt unless explicitly hidden
        if (userCanSeeUpgrade && !hideUpgrade) {
            return (
                <BasePage>
                    <FeatureUpgradeContent feature={feature} />
                </BasePage>
            );
        }

        // Others see fallback (redirect, empty state, etc.)
        return fallback;
    }

    return children;
};
